export default __webpack_public_path__ + "static/media/bestbackend.5a37e3d8.md";